var React = require('react');
var createReactClass = require('create-react-class');
var FuzzyReaction = require('../../bootstrap').FuzzyReaction;
var Column = FuzzyReaction.Components.PageStructure.Column;
var Row = FuzzyReaction.Components.PageStructure.Row;
var Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
var ResourceActions = FuzzyReaction.Actions.ResourceActions;
var FormStore = FuzzyReaction.Stores.FormStore;
var MenuUrlsStore = require('../../stores/MenuUrlsStore');

/**
 * The Menu Items list page view component
 *
 * @type {*|Function}
 */


var MenuUrlsPage = createReactClass({
    displayName: 'MenuUrlsPage',

    getInitialState: function () {
		return {
			workingResource: {},
			menuUrls:        []
		}
	},

    /**
	 * Set up resource actions
	 */
    resourceActions: new ResourceActions('menu-items'),

    /**
	 * Resource action options
	 */
    getOptions: {
		modifiers: {},
		dataNode: 'data'
	},

    sendOptions: {
		modifiers: {
			other: {
				show_deleted: true
			}
		},
		dataNode: 'data'
	},

    formKey: 'editMenuUrls',

    /**
	 * Fire an action to request data from the API
	 */
    requestMenuUrlData: function () {
		this.resourceActions.listResource(this.getOptions);
	},

    /**
	 * Register event listeners and fire request for data
	 */
    componentDidMount: function () {
		this.requestMenuUrlData();

		this.changeListener = this._onChange;
		MenuUrlsStore.addChangeListener(this.changeListener);
		FormStore.addChangeListener(this.bindResource);
	},

    /**
	 * Deregister an event listener
	 */
    componentWillUnmount: function () {
		MenuUrlsStore.removeChangeListener(this.changeListener);
		FormStore.removeChangeListener(this.bindResource);
	},

    /**
	 * Handle changes in data and request paginated datas
	 *
	 * @private
	 */
    _onChange: function () {
		this.setState({
			menuUrls: MenuUrlsStore.getMenuUrlData()
		});

		this.forceUpdate();
	},

    /**
	 * Fire the activate URLs action
	 */
    updateUrls: function (event) {
		var thisComponent = this;

		// @todo Magic does not yet support bulk updates
		this.state.menuUrls.map(function (menuUrl, index) {
			thisComponent.resourceActions.updateResource(menuUrl, thisComponent.sendOptions);
		});
	},

    /**
	 * Bind resource callback
	 */
    bindResource: function () {
		this.setState({
			menuUrls:        FormStore.getResource(this.formKey),
			formIsValid: FormStore.isFormValid(this.formKey)
		});
	},

    /**
	 * Take an ugly underscore separated slug and make it pretty
	 *
	 * @param {string} slug
	 * @returns {string}
	 * @private
	 */
    _prettifySlug: function (slug) {
		// Lowercase, explode, capitalize first letter, space-separate, and format 'Url'
		return slug.toLowerCase().split('_').map(function (part, index) {
			return part.charAt(0).toUpperCase() + part.slice(1);
		}).join(' ').replace('Url', 'URL');
	},

    /**
	 * Creates a dynamic form
	 */
    buildForm: function () {
		return this.state.menuUrls.map(function (menuUrls, index) {
			return (
				<Column key={index} grid="sm" size="8">
					<Form.Input fieldKey={index + '.url'} type="url" label={this._prettifySlug(menuUrls.slug)} placeholder="Menu URL"
						limit={120} validations="isURL" />
				</Column>
			);
		}.bind(this));
	},

    render: function () {
		// Force form component to update by providing it with a new key
		var uniqueFormKey = this.state.menuUrls.length ? '_withData' : '_withoutData';

		return (
			<div id="page-wrapper">
				<div id="page-content">
					<div id="content"></div>

					<Row classes="align-items-center">
						<Column grid="lg" size="6">
							<h1 className="page-header">Menu URLs</h1>
						</Column>
					</Row>

					<Row>
						<Column grid="lg" size="12">
							<div className="card card-default">
								<div className="card-header">
									Manage Webview Menu Item URLS
								</div>
								<Row>
									<div className="card-body">
										<Column grid="lg" size="4" classes="float-right">
											<span className="input-group-btn">
												<button className="btn btn-primary btn-sm" id="btn-submit" onClick={this.updateUrls}>
													Save Changes
												</button>
											</span>
										</Column>
										<Column grid="lg" size="8">
											<Form key={uniqueFormKey} formKey={this.formKey}
												bindResource={this.state.menuUrls} >
												<Column grid="sm" size="12">
													<Row>
														{this.buildForm()}
													</Row>
												</Column>
											</Form>
										</Column>
									</div>
								</Row>
							</div>
						</Column>
					</Row>
				</div>
			</div>

		)
	},
});

module.exports = MenuUrlsPage;

